import {
  selectCurrentAction,
  selectPreviewMode,
} from '@/redux/customisation/selector'
import React, { ReactNode } from 'react'
import { useSelector } from 'react-redux'

export const syncPrewiewUITypes = {
  SCROLL_INTO_VIEW: 'SCROLL_INTO_VIEW',
  CHANGE_SECTION_SETTING_STEP: 'CHANGE_SECTION_SETTING_STEP',
}

const PreviewUISync = ({
  sectionId,
  onPreviewModeScrollIntoView,
  onPreviewModeChangeSectionSettingStep,
}: {
  sectionId: string
  onPreviewModeScrollIntoView?: () => void
  onPreviewModeChangeSectionSettingStep?: (params: any) => void
}): ReactNode => {
  const previewMode = useSelector(selectPreviewMode)
  const currentAction = useSelector(selectCurrentAction)
  const [prevAction, setPrevAction] = React.useState(currentAction)

  React.useEffect(() => {
    if (previewMode && prevAction !== currentAction) {
      const { type, payload } = currentAction
      if (
        type === '@@preview/SYNC_PREVIEW_UI' &&
        payload.sectionId === sectionId
      ) {
        let action
        switch (payload.action) {
          case syncPrewiewUITypes.SCROLL_INTO_VIEW:
            action = onPreviewModeScrollIntoView
            break
          case syncPrewiewUITypes.CHANGE_SECTION_SETTING_STEP:
            action = onPreviewModeChangeSectionSettingStep
            break
        }
        if (typeof action === 'function') {
          action(payload)
        }
        setPrevAction(currentAction)
      }
    }
  }, [
    currentAction,
    onPreviewModeChangeSectionSettingStep,
    onPreviewModeScrollIntoView,
    prevAction,
    previewMode,
    sectionId,
  ])

  return null
}

export default PreviewUISync
